import { useState, useEffect } from "react";
import { Modal } from "../ui/Modal";
import { Button } from "../ui/Button";

interface PaymentFilters {
  status: string;
  paymentMethod: string;
}

interface PaymentFiltersDialogProps {
  isOpen: boolean;
  onClose: () => void;
  filters: PaymentFilters;
  onApply: (filters: PaymentFilters) => void;
}

export function PaymentFiltersDialog({
  isOpen,
  onClose,
  filters,
  onApply,
}: PaymentFiltersDialogProps) {
  const [localFilters, setLocalFilters] = useState<PaymentFilters>(filters);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters, isOpen]);

  if (!isOpen) return null;

  const handleApply = () => {
    onApply(localFilters);
    onClose();
  };

  const handleReset = () => {
    const defaultFilters: PaymentFilters = {
      status: "all",
      paymentMethod: "all",
    };
    setLocalFilters(defaultFilters);
    onApply(defaultFilters);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Filter Payments"
      className="max-w-md"
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Status
          </label>
          <select
            value={localFilters.status}
            onChange={(e) =>
              setLocalFilters({ ...localFilters, status: e.target.value })
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="all">All Statuses</option>
            <option value="pending">Pending</option>
            <option value="completed">Completed</option>
            <option value="failed">Failed</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Payment Method
          </label>
          <select
            value={localFilters.paymentMethod}
            onChange={(e) =>
              setLocalFilters({
                ...localFilters,
                paymentMethod: e.target.value,
              })
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="all">All Methods</option>
            <option value="paytabs">Card (PayTabs)</option>
            <option value="credit_card">Credit Card</option>
            <option value="bank_transfer">Bank Transfer</option>
            <option value="cash">Cash</option>
            <option value="legacy">Legacy</option>
          </select>
        </div>

        <div className="flex gap-3 pt-6 border-t border-gray-100 mt-6">
          <Button variant="outline" className="flex-1" onClick={handleReset}>
            Reset
          </Button>
          <Button variant="primary" className="flex-1" onClick={handleApply}>
            Apply Filters
          </Button>
        </div>
      </div>
    </Modal>
  );
}
